function showOneButtonStandard(text, minTop)
{
    const button = document.getElementById("button1");

    if (minTop === undefined) {
        minTop = -Infinity;
    }

    setResponseTopPosition();
    const legacyTopValue = Math.max(+buttonTopDefault-50, minTop);
    const newTopValue = currentButtonTop + 50;
    const buttonTopValue = legacyTopValue > newTopValue ? legacyTopValue : newTopValue;
    button.innerHTML = text;
    button.style.width = width1button + "px";
    button.style.top = buttonTopValue + "px";
    button.style.left = (canvasWidth/2 - width1button/2) + "px";
    button.style.zIndex = 100;
    button.style.display = "block";
    button.blur();
}
